import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useRegularizacion } from '../../context/RegularizacionContext';
import { rutaPanelPendientes } from '../../utils/comprobanteEntidad';

/** Mientras la entidad propia tenga comprobantes con más de 7 días, lo recuerda arriba de cada página. */
export const FranjaRegularizacion: React.FC = () => {
  const { entidad, vencidos } = useRegularizacion();
  if (!entidad || vencidos.length === 0) return null;
  return (
    <div
      role="status"
      className="mb-4 flex flex-wrap items-center justify-center gap-x-2 rounded-lg bg-amber-100 border border-amber-300 px-4 text-sm text-amber-900"
    >
      <AlertTriangle className="w-4 h-4" aria-hidden="true" />
      <span>{vencidos.length === 1 ? 'Falta 1 comprobante' : `Faltan ${vencidos.length} comprobantes`} con más de 7 días</span>
      <span aria-hidden="true">·</span>
      <Link to={rutaPanelPendientes(entidad)} className="min-h-11 inline-flex items-center font-semibold underline">
        Ver pendientes
      </Link>
    </div>
  );
};
